import store from "./store.js";

// All operations on dates in this app use the UTC methods of the Date class.
// This is done to support maniuplation of dates in timezones other than the viewing
// browser's timezone. Using the non-UTC methods would, for example, prevent a browser
// in the Atlantic timezone from selecting "March 8th 2:00AM, 2020" as a date. It is a
// valid date/time in Saskatchewan but not in the Atlantic provinces.

// Shifts the date so that the UTC methods return the local time of the desired timezone.
// The 'utc' param is either a 'Date' object or a UTC timestamp in milliseconds.
export function zoneDate(utc, zoneName) {
  let date = new Date(utc);
  let timestampMs = date.getTime();
  let timestamp = timestampMs / 1000;

  let timezones = store.sessions[0].system.timezones.value;
  let zone = timezones.find(tz => zoneName == tz.name_olson);
  let stdOffset = zone.standardOffset * 60;
  let dstRange = zone.daylightTimes.find(range => timestamp >= range[0] && timestamp < range[1]);
  let zoneOffset = dstRange ? stdOffset + 3600 : stdOffset;
  let zoneOffsetMs = zoneOffset * 1000;
  return new Date(timestampMs + zoneOffsetMs);
}

// Returns the equivalent UTC time, given a 'local' time.
// When there are two possible equivalent UTC times, for example when the
// provided 'local' time is 1:30am on the day in which DST ends, then the 
// earlier UTC time is returned.
export function dezoneDate(zonedDate, zoneName) {
  if (typeof zonedDate == "number")
    zonedDate = new Date(zonedDate);
  
  let zonedTimestamp = zonedDate.getTime();
  let tryFrom = zonedTimestamp - (12 * 60 * 60 * 1000);
  let tryTo = zonedTimestamp + (12 * 60 * 60 * 1000);
  for (let timestamp = tryFrom; timestamp <= tryTo; timestamp += (30 * 60 * 1000)) {
    let local = zoneDate(timestamp, zoneName);
    if (local.getTime() >= zonedTimestamp) {
      return new Date(timestamp);
    }
  }
}